var _defs, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.237,
    height: 26.5
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".calendar2_svg__a{isolation:isolate}.calendar2_svg__b{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "calendar2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "calendar2_svg__b",
    d: "M17.171.75v9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "calendar2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "calendar2_svg__b",
    d: "M7.066.75v9"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "calendar2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "calendar2_svg__b",
    d: "M.75 10.592h22.737"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "calendar2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "calendar2_svg__b",
    d: "M20.961 6.25H3.276A2.418 2.418 0 00.75 8.544v14.912a2.418 2.418 0 002.526 2.294h17.685a2.418 2.418 0 002.526-2.294V8.544a2.418 2.418 0 00-2.526-2.294z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "calendar2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "calendar2_svg__b",
    d: "M.868 15.645h22.5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    className: "calendar2_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "calendar2_svg__b",
    d: "M4.284 20.697h11.25"
  }))));
}
export default SvgCalendar2;


//////////////////
// WEBPACK FOOTER
// ./src/icons/calendar2.svg
// module id = 732
// module chunks = 11